export const translations = {
  es: {
    // Navigation
    products: 'PRODUCTOS',
    services: 'SERVICIOS',
    support: 'SOPORTE',
    industries: 'INDUSTRIAS',
    learning: 'APRENDIZAJE',
    about: 'NOSOTROS',
    contact: 'CONTACTO',
    buy: 'COMPRAR',
    search: 'BUSCAR',
    search_placeholder: 'Buscar en ECOSOFT...',
    
    // Product Menu
    opus_modules: 'Módulos OPUS',
    budget_module: 'OPUS M1 PRESUPUESTO PROGRAMABLE',
    planning_module: 'OPUS M2 PLANEACIÓN Y CONTROL INTEGRAL',
    purchases_module: 'OPUS M3 ADMINISTRACIÓN DE COMPRAS',
    dependencies_module: 'OPUS M4 DEPENDENCIAS',
    bim_module: 'OPUS M5 CUANTIFICACIÓN BIM',
    erp_module: 'OPUS ERP ENTERPRISE',
    
    // Support Menu
    downloads: 'DESCARGAS',
    support_request: 'CONTACTO',
    faq: 'PREGUNTAS FRECUENTES',
    videos: 'ACADEMIA OPUS (VIDEOS)',
    
    // Industries Menu
    construction: 'CONSTRUCCIÓN',
    infrastructure: 'INFRAESTRUCTURA',
    architecture: 'ARQUITECTURA',
    real_estate: 'INMOBILIARIA',
    
    // Learning Menu
    courses: 'CURSOS',
    certifications: 'CERTIFICACIONES',
    webinars: 'WEBINARS',
    
    // Common
    learn_more: 'Conocer más',
    download: 'Descargar',
    try_free: 'Descargar',
    contact_sales: 'Contactar ventas',
    see_purchase_options: 'Ver opciones de compra'
  },
  en: {
    // Navigation
    products: 'PRODUCTS',
    services: 'SERVICES',
    support: 'SUPPORT',
    industries: 'INDUSTRIES',
    learning: 'LEARNING',
    about: 'ABOUT',
    contact: 'CONTACT',
    buy: 'BUY',
    search: 'SEARCH',
    search_placeholder: 'Search ECOSOFT...',
    
    // Product Menu
    opus_modules: 'OPUS Modules',
    budget_module: 'OPUS M1 BUDGET & SCHEDULING',
    planning_module: 'OPUS M2 PLANNING & CONTROL',
    purchases_module: 'OPUS M3 PURCHASE MANAGEMENT',
    dependencies_module: 'OPUS M4 DEPENDENCIES',
    bim_module: 'OPUS M5 BIM QUANTIFICATION',
    erp_module: 'OPUS ERP ENTERPRISE',
    
    // Support Menu
    downloads: 'DOWNLOADS',
    support_request: 'SUPPORT REQUEST',
    faq: 'FAQ',
    videos: 'OPUS ACADEMY (VIDEOS)',
    
    // Industries Menu
    construction: 'CONSTRUCTION',
    infrastructure: 'INFRASTRUCTURE',
    architecture: 'ARCHITECTURE',
    real_estate: 'REAL ESTATE',
    
    // Learning Menu
    courses: 'COURSES',
    certifications: 'CERTIFICATIONS',
    webinars: 'WEBINARS',
    
    // Common
    learn_more: 'Learn more',
    download: 'Download',
    try_free: 'Try for free',
    contact_sales: 'Contact sales',
    see_purchase_options: 'See purchase options'
  }
}; 